/* SHEFORMA PDP — sticky bar, hero scrub, buy box + real cart wiring */

/* sticky ATC bar: sale quando il buy box esce dallo schermo e resta su fino a fondo pagina.
   Nascondeva la barra sui CTA di .offer2 e .sfaq per non mostrare due CTA insieme, ma
   "elemento a schermo" dura un viewport intero di scroll: due bottoni da 58px tenevano la
   barra giu' per ~900px l'uno, cioe' quasi tutti gli ultimi 1700px della pagina. Era il
   "sparisce e poi ricompare" segnalato il 04/08. Il footer ha gia' il padding per la barra
   (pdp.css: body:has(.atcbar.on) .hfoot), quindi non serve nasconderla in fondo. */
/* Niente IntersectionObserver qui: notifica solo le TRANSIZIONI. Un salto che scavalca il
   bottone senza attraversarlo (ancora #faq/#sizelab dal menu, back/forward, ripristino dello
   scroll al reload) non fa partire nessuna callback e la barra resta nello stato vecchio —
   assente a meta' pagina finche' non riattraversi il buy box. Lo stato si ricalcola dal rect. */
(function(){
  var bar=document.getElementById('atcbar'), btn=document.getElementById('atcbtn'), raf=0;
  if(!bar||!btn) return;
  function sync(){ raf=0; bar.classList.toggle('on', btn.getBoundingClientRect().bottom < 0); }
  function queue(){ if(!raf) raf=requestAnimationFrame(sync); }
  /* capture:true e' obbligatorio: da desktop la pagina NON scrolla nella finestra, scrolla
     dentro .page-wrapper (body ha overflow:hidden). Gli eventi scroll non fanno bubbling, ma
     in fase di cattura passano da window fino al target, quindi li prendiamo comunque. */
  addEventListener('scroll', queue, {passive:true, capture:true});
  addEventListener('resize', queue, {passive:true});
  sync();
})();

/* rimosso: l'IIFE #walkvid — quel video non esiste piu' nel markup (grep 0 hit in pdp.liquid) */

/* ATF buy box: gallery, selectors, deal cards, REAL add-to-cart */
(function(){
  var track=document.getElementById('galtrack');
  if(!track) return;
  var dots=[].slice.call(document.querySelectorAll('#galdots button'));
  var thumbs=[].slice.call(document.querySelectorAll('#galthumbs button'));
  var gic=document.querySelector('.gal .gicons');
  var gfast=document.querySelector('.gal .gbadge--fast');
  var thumbstrip=document.getElementById('galthumbs'), curDot=-1;
  /* ponytail: the strip follows the main track's scroll progress 1:1 instead of running a smooth
     scrollTo per slide — a smooth animation restarted by every scroll event is what crawled/jumped.
     Proportional lands within ~3px of "center the active thumb" for this strip. */
  function syncStrip(){
    if(!thumbstrip) return;
    var tmax=track.scrollWidth-track.clientWidth, smax=thumbstrip.scrollWidth-thumbstrip.clientWidth;
    if(tmax<=0||smax<=0) return;
    thumbstrip.scrollLeft=track.scrollLeft/tmax*smax;
  }
  function setDot(i){
    i=Math.max(0,Math.min(i,dots.length-1));
    if(i===curDot) return;
    curDot=i;
    if(gic) gic.classList.toggle('off', i!==0);
    if(gfast) gfast.classList.toggle('off', i!==0);
    dots.forEach(function(d,j){ d.classList.toggle('sel', j===i); });
    thumbs.forEach(function(t,j){ t.classList.toggle('sel', j===i); });
    if(prevB) prevB.disabled = i<=0;
    if(nextB) nextB.disabled = i>=dots.length-1;
  }
  var galraf=0;
  track.addEventListener('scroll',function(){
    if(galraf) return;
    galraf=requestAnimationFrame(function(){
      galraf=0;
      syncStrip();
      setDot(Math.round(track.scrollLeft / track.clientWidth));
    });
  },{passive:true});
  function goTo(i){ track.scrollTo({left:i*track.clientWidth,behavior:'smooth'}); }
  function curIdx(){ return Math.round(track.scrollLeft/track.clientWidth); }
  var prevB=document.querySelector('[data-gal-prev]'), nextB=document.querySelector('[data-gal-next]');
  if(prevB) prevB.addEventListener('click',function(){ goTo(Math.max(0,curIdx()-1)); });
  if(nextB) nextB.addEventListener('click',function(){ goTo(Math.min(dots.length-1,curIdx()+1)); });
  setDot(0);
  dots.forEach(function(d,i){ d.addEventListener('click',function(){ goTo(i); }); });
  thumbs.forEach(function(t,i){ t.addEventListener('click',function(){ goTo(i); }); });

  var VARIANTS=[];
  try{ VARIANTS=JSON.parse(document.getElementById('pdp-variants').textContent); }catch(e){}
  /* BOGO offer: SET-BOGO = 50% off jellyhold, min qty 4 (created store-side). One code at
     every tier: a percentage scales past 6, unlike the old fixed-amount SET-BOGO4/SET-BOGO6
     pair that capped at -$149.97. The unit price is $49.98 (NOT $49.99) precisely so half
     of it is an exact cent: a bra costs $24.99 and the tiers are $99.96 / $149.94, which is
     2x and 3x the unit price to the cent — the prices advertised in pdp.liquid. Bump the
     unit price only to another even-cent value, or the rounding gap comes back.
     See snippets/hollow-cart-blocks.liquid for why a Buy-X-Get-Y was tried and dropped.
     ponytail: /discount/ cookie + /cart/add.js; swap for Kaching bundles if chosen later */
  var CODES={4:'SET-BOGO',6:'SET-BOGO'};

  /* Il popup plinko scrive {code,expiresAt} in localStorage quando qualcuno vince il
     jackpot. La chiave e' "alia_<shop>:jackpot": il tema non conosce lo shop, quindi
     cerca per suffisso. Scaduto = non esiste piu'. */
  function sfJackpotLive(){
    try{
      for(var i=0;i<localStorage.length;i++){
        var k=localStorage.key(i);
        if(k&&k.slice(-8)===':jackpot'){
          var j=JSON.parse(localStorage.getItem(k)||'{}');
          if(j.code&&Date.parse(j.expiresAt||'')>Date.now()) return true;
        }
      }
    }catch(e){}
    return false;
  }


  var atc=document.getElementById('atcbtn');
  /* i18n: window.PDP_IT set by liquid before this script */
  var IT=!!window.PDP_IT;
  var T=IT?{
    atc:'Aggiungi al carrello', atcPick:'Seleziona la taglia', save:'Risparmi $', color:'Colore: ', sizeWord:'Taglia',
    names:{1:'Starter · 1 reggiseno',4:'Compri 2, 2 gratis · 4 reggiseni',6:'Compri 3, 3 gratis · 6 reggiseni'},
    bras:' reggiseni', barpr:' · reso facile 99 giorni', sizePh:'Seleziona fascia e coppa', sizeCap:'Taglia ',
    selSize:'Scegli prima la tua taglia.', sizeErr:'Per favore selezionare la taglia', unavail:'Questa combinazione taglia/colore non è disponibile al momento.',
    cartErr:'Non siamo riusciti ad aggiungere al carrello. Riprova.', adding:'Aggiungo…'
  }:{
    atc:'Add to cart', atcPick:'Select your size', save:'Save $', color:'Color: ', sizeWord:'Size',
    names:{1:'Starter · 1 bra',4:'Buy 2, Get 2 Free · 4 bras',6:'Buy 3, Get 3 Free · 6 bras'},
    bras:' bras', barpr:' · free shipping', sizePh:'Select your band and cup', sizeCap:'Size ',
    selSize:'Please select your size.', sizeErr:'Please use the selectors below to pick a size', unavail:'This size/color combination is unavailable right now.',
    cartErr:'Could not add to cart. Please try again.', adding:'Adding…'
  };
  /* il prezzo iniziale si legge dal tier gia' selezionato, non si scrive qui: in un market
     non-USD (UK) e' in sterline e lo stampa liquid via snippets/sf-price.liquid */
  var sfSelDeal=document.querySelector('#deals .deal.sel');
  var state={color:'Nude', colors:['Nude'], sizes:[], band:'', cup:'', n:'1',
             price:(sfSelDeal&&sfSelDeal.dataset.price)||''};
  var SIZES=[]; VARIANTS.forEach(function(v){ if(v.option2 && SIZES.indexOf(v.option2)<0) SIZES.push(v.option2); });
  function atcReady(){
    if(!state.band) return false;
    var n=parseInt(state.n,10)||1;
    for(var i=0;i<n;i++){ if(!state.colors[i]) return false; }
    return true;
  }
  function updateAtcState(){
    var ok=atcReady();
    /* aria-disabled, non disabled: il bottone resta tabbabile e il tap fa scattare
       l'errore taglia in addToCart invece di non fare assolutamente niente */
    /* totale della selezione corrente sul bottone (Hollow-style trasparenza: mai
       un importo a sorpresa nel drawer). state.price = dataset.price del tier sel. */
    var tot=(ok&&state.price)?' <span class="atc-total">· '+state.price+'</span>':'';
    if(atc){ atc.setAttribute('aria-disabled', ok?'false':'true'); atc.innerHTML='<span class="atc-main">'+(ok?T.atc:T.atcPick)+tot+'</span>'; }
  }
  function syncAtc(){
    updateAtcState();
  }
  function pick(group, b, cb){
    group.querySelectorAll('button').forEach(function(x){ x.classList.remove('sel'); x.setAttribute('aria-pressed','false'); });
    b.classList.add('sel'); b.setAttribute('aria-pressed','true');
    cb(b); syncAtc();
  }
  // ---- COLOR: one picker row per bra in the pack (Shapermint per-unit) ----
  var COLORS=[]; try{COLORS=JSON.parse(document.getElementById('pdp-colors').textContent);}catch(e){}
  var colorpack=document.getElementById('colorpack'), colornames=document.getElementById('colornames');
  var lastIdx=0; /* riga toccata per ultima: il re-focus dopo il rerender deve tornare li', non a bra #1 */
  function colorByName(n){ for(var i=0;i<COLORS.length;i++){ if(COLORS[i].name===n) return COLORS[i]; } return COLORS[0]; }
  /* ponytail: warm every 140px thumb once so a swatch tap swaps from cache, no network wait.
     Dopo l'evento load, non durante: misurato nel waterfall, questo warm valeva 28,3 KB su 9
     richieste dentro la finestra critica, in competizione con l'hero LCP. Il tap arriva comunque
     molto dopo il load, quindi la cache e' pronta lo stesso. */
  var warmSwatches = function(){
    COLORS.forEach(function(c){ if(c.thumb){ var p=new Image(); p.decoding='async'; p.src=c.thumb; } });
  };
  if(document.readyState==='complete') warmSwatches(); else addEventListener('load', warmSwatches, {once:true});
  function renderColors(){
    if(!colorpack || !COLORS.length) return;
    var n=parseInt(state.n,10)||1;
    while(state.colors.length<n) state.colors.push(COLORS[0].name);
    state.colors.length=n;
    var hadFocus=colorpack.contains(document.activeElement);
    colorpack.innerHTML='';
    state.colors.forEach(function(sel,idx){
      var c=colorByName(sel);
      var row=document.createElement('div'); row.className='cprow';
      var img=document.createElement('img'); img.className='thumb'; img.src=c.thumb; img.alt=c.name; img.width=60; img.height=60; img.decoding='sync';
      var info=document.createElement('div'); info.className='cpinfo';
      var nm=document.createElement('div'); nm.className='cpname'; nm.innerHTML=T.color+'<b>'+c.name+'</b>'; nm.setAttribute('data-err',T.selSize);
      var sws=document.createElement('div'); sws.className='cpswatches';
      COLORS.forEach(function(col){
        var b=document.createElement('button'); b.type='button';
        b.className='cpswatch'+(col.name===sel?' sel':''); b.style.background=col.hex; if(col.sw){ b.style.backgroundImage="url("+col.sw+")"; b.style.backgroundSize="cover"; b.style.backgroundPosition="center center"; } else { b.style.backgroundImage="none"; }
        b.setAttribute('aria-label',col.name); b.title=col.name;
        b.addEventListener('click',function(){
          state.colors[idx]=col.name;
          lastIdx=idx;
          renderColors();
          var _sl=document.querySelector('#galtrack .slide[data-color="'+col.name+'"]');
          var _tr=document.getElementById("galtrack");
          if(_sl&&_tr){ _tr.scrollLeft=_sl.offsetLeft; }
        });
        sws.appendChild(b);
      });
      info.appendChild(nm); info.appendChild(sws);
      row.appendChild(img); row.appendChild(info); colorpack.appendChild(row);
    });
    if(hadFocus){ var _row=colorpack.querySelectorAll('.cprow')[lastIdx]; var reFocus=(_row||colorpack).querySelector('.cpswatch.sel'); if(reFocus) reFocus.focus({preventScroll:true}); }
    if(colornames) colornames.textContent=state.colors.join(', ');
    state.color=state.colors[0];
    updateAtcState();
  }
  renderColors();

  // ---- SIZE: single global pill row (Shapermint — one size for the whole pack) ----
  var sizeglobal=document.getElementById('sizeglobal'), sizename=document.getElementById('sizename');
  function renderSizes(){
    if(!sizeglobal) return;
    var hadFocusS=sizeglobal.contains(document.activeElement);
    sizeglobal.innerHTML='';
    SIZES.forEach(function(letter){
      var sb=document.createElement('button'); sb.type='button';
      sb.className='cpszbtn'+(letter===state.band?' sel':'');
      sb.textContent=letter;
      sb.setAttribute('aria-label',T.sizeWord+' '+letter);
      sb.setAttribute('aria-pressed',letter===state.band?'true':'false');
      sb.addEventListener('click',function(){ state.band=letter; sizeglobal.classList.remove('is-err'); renderSizes(); syncAtc(); });
      sizeglobal.appendChild(sb);
    });
    if(hadFocusS){ var reFocusS=sizeglobal.querySelector('.cpszbtn.sel'); if(reFocusS) reFocusS.focus(); }
    if(sizename) sizename.textContent=state.band||T.atcPick;
    updateAtcState();
  }
  renderSizes();

  // ---- SIZE: Band + Cup = Size — unica fonte: JSON #sf-size-data nel liquid (alimenta quiz E tabella) ----
  var SIZE_DATA=(function(){ var el=document.getElementById('sf-size-data'); if(!el) return null; try{ return JSON.parse(el.textContent); }catch(e){ return null; } })();
  var SIZE_MATRIX=(SIZE_DATA&&SIZE_DATA.matrix)||{};
  (function(){ /* tbody della Size Chart generato dalla stessa matrice: divergenza quiz/tabella impossibile */
    var tb=document.querySelector('[data-sf-schart]');
    if(!tb||!SIZE_DATA) return;
    SIZE_DATA.bands.forEach(function(b){
      var tr=document.createElement('tr'), th=document.createElement('th');
      th.textContent=SIZE_DATA.cm?b[1]:b[0]; tr.appendChild(th);
      SIZE_DATA.cups.forEach(function(c){ var td=document.createElement('td'); td.textContent=SIZE_MATRIX[b[0]][c]; tr.appendChild(td); });
      tb.appendChild(tr);
    });
  })();

  // ---- SIZE POP-QUIZ (Leishape ls-sfg, 3 steps) ----
  var quiz=document.getElementById('sizequiz');
  if(quiz){
    var qSteps=[].slice.call(quiz.querySelectorAll('.ls-sfg__step'));
    var qDots=[].slice.call(quiz.querySelectorAll('.ls-sfg__quiz-dot'));
    var qBack=quiz.querySelector('[data-sfg-back]');
    var qApply=quiz.querySelector('[data-sfg-apply]');
    var qState={band:'',bandLabel:'',cup:'',typical:'',size:''}, qStep=1;
    function selOne(sel,btn){ quiz.querySelectorAll(sel).forEach(function(x){x.classList.remove('is-on'); x.setAttribute('aria-pressed','false');}); btn.classList.add('is-on'); btn.setAttribute('aria-pressed','true'); }
    function qRecalc(){
      /* SOLO la matrice decide: mai ripiegare in silenzio sulla taglia "che porti di solito"
         (il fallback ||typical restituiva il reggiseno attuale — quasi sempre troppo piccolo per DD-F) */
      var letter=(qState.band&&qState.cup&&SIZE_MATRIX[qState.band]&&SIZE_MATRIX[qState.band][qState.cup])||'';
      qState.size=letter;
      var bc=quiz.querySelector('[data-sfg-formula-bc]'), rv=quiz.querySelector('[data-sfg-result-val]'), un=quiz.querySelector('[data-sfg-unavail]');
      /* recap: mostra l'etichetta toccata (cm fuori US), non il valore imperiale interno */
      if(bc) bc.textContent=(qState.band&&qState.cup)?((qState.bandLabel||qState.band)+' · '+qState.cup):(qState.typical||'—');
      if(rv) rv.textContent=letter||'—';
      if(un) un.hidden=true;                 /* all S-5XL stocked on Sheforma */
      if(qApply) qApply.hidden=!letter;
    }
    function qShow(n){
      qStep=n;
      qSteps.forEach(function(s){ s.classList.toggle('is-on', s.getAttribute('data-sfg-step')===String(n)); });
      qDots.forEach(function(d,i){ d.classList.toggle('is-on', i<n); });
      if(qBack) qBack.hidden=(n===1);
      if(n===3) qRecalc();
    }
    quiz.querySelectorAll('[data-sfg-band] .ls-sfg__rect').forEach(function(b){
      b.addEventListener('click',function(){ selOne('[data-sfg-band] .ls-sfg__rect',b); qState.band=b.getAttribute('data-sfg-band-val'); qState.bandLabel=(b.textContent||'').trim(); if(qState.band&&qState.cup) qShow(2); });
    });
    quiz.querySelectorAll('[data-sfg-cup] .ls-sfg__rect').forEach(function(b){
      b.addEventListener('click',function(){ selOne('[data-sfg-cup] .ls-sfg__rect',b); qState.cup=b.getAttribute('data-sfg-cup-val'); if(qState.band&&qState.cup) qShow(2); });
    });
    quiz.querySelectorAll('[data-sfg-typical] .ls-sfg__rect').forEach(function(b){
      b.addEventListener('click',function(){ selOne('[data-sfg-typical] .ls-sfg__rect',b); qState.typical=b.getAttribute('data-sfg-typical-val'); qShow(3); });
    });
    if(qBack) qBack.addEventListener('click',function(){ if(qStep>1) qShow(qStep-1); });
    var qRestart=quiz.querySelector('[data-sfg-restart]');
    if(qRestart) qRestart.addEventListener('click',function(){ qState={band:'',bandLabel:'',cup:'',typical:'',size:''}; quiz.querySelectorAll('.ls-sfg__rect.is-on').forEach(function(x){x.classList.remove('is-on'); x.setAttribute('aria-pressed','false');}); qShow(1); });
    if(qApply) qApply.addEventListener('click',function(){
      /* ricalcola all'apply: la taglia applicata è SEMPRE quella appena derivata da band+cup,
         mai uno stato stantio (replay 27/08: mostrato 2XL, applicato 4XL) */
      qRecalc();
      if(qState.size){ state.band=qState.size; if(qState.cup) state.cup=qState.cup; renderSizes(); syncAtc(); }
      closeQuiz();
    });
    var quizOpener=null;
    function openQuiz(){
      quizOpener=document.activeElement;
      quiz.hidden=false; document.body.style.overflow='hidden';
      /* il backdrop e' un div con data-size-chart-close: non e' focusabile e il focus resterebbe
         fuori dal modale, disattivando la trappola Tab qui sotto. Serve un elemento vero. */
      var first=quiz.querySelector('button[data-size-chart-close], button, [href], input, select, textarea');
      if(first) first.focus();
    }
    function closeQuiz(){
      quiz.hidden=true; document.body.style.overflow='';
      if(quizOpener && document.contains(quizOpener)) quizOpener.focus();
      quizOpener=null;
    }
    /* aria-modal non basta: senza questo il Tab esce dal modale e gira sulla pagina sotto */
    quiz.addEventListener('keydown',function(e){
      if(e.key!=='Tab' || quiz.hidden) return;
      var f=[].slice.call(quiz.querySelectorAll('button, [href], input, select, textarea, summary, [tabindex]:not([tabindex="-1"])'))
        .filter(function(el){ return !el.disabled && el.offsetParent !== null; });
      if(!f.length) return;
      var first=f[0], last=f[f.length-1];
      if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
    });
    document.querySelectorAll('[data-size-chart-open]').forEach(function(b){ b.addEventListener('click',openQuiz); });
    quiz.querySelectorAll('[data-size-chart-close]').forEach(function(b){ b.addEventListener('click',closeQuiz); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!quiz.hidden) closeQuiz(); });
  }
  var deals=document.getElementById('deals');
  var savepack=document.getElementById('savepack');
  function setPackLabel(d){ if(savepack) savepack.textContent=d.dataset.pack?': '+d.dataset.pack:''; }
  deals.querySelectorAll('.deal').forEach(function(d){
    d.addEventListener('click',function(){
      deals.querySelectorAll('.deal').forEach(function(x){x.classList.remove('sel')});
      d.classList.add('sel');
      state.n=d.dataset.n; state.price=d.dataset.price;
      setPackLabel(d); renderColors(); syncAtc();
    });
  });
  var selDeal=deals.querySelector('.deal.sel');
  if(selDeal){ state.n=selDeal.dataset.n; state.price=selDeal.dataset.price; setPackLabel(selDeal); renderColors(); }
  syncAtc();

  function variantFor(color,size){
    for(var i=0;i<VARIANTS.length;i++){
      var v=VARIANTS[i];
      if(v.option1===color && v.option2===size) return v.id;
    }
    return null;
  }
  var busy=false;
  function addToCart(btn){
    if(busy) return;
    if(!state.band){
      if(sizeglobal){ sizeglobal.classList.add('is-err'); sizeglobal.scrollIntoView({behavior:'smooth',block:'center'}); }
      return;
    }
    var unitSizes=state.colors.map(function(){ return state.band; });
    busy=true;
    /* group per-unit color+size → one cart line per combo */
    var counts={}; state.colors.forEach(function(c,i){ var k=c+'|||'+unitSizes[i]; counts[k]=(counts[k]||0)+1; });
    var props={}; /* niente property per-riga: la stessa variante deve fare UNA riga sola */
    var items=[], missing=false;
    Object.keys(counts).forEach(function(k){
      var parts=k.split('|||');
      var id=variantFor(parts[0],parts[1]); if(!id){ missing=true; return; }
      items.push({id:id,quantity:counts[k],properties:props});
    });
    if(missing || !items.length){ alert(T.unavail); busy=false; return; }
    var prev=btn.innerHTML; btn.textContent=T.adding;
    /* ponytail: open the drawer on the tap, spinner-covered, instead of after
       /discount + /cart/add.js + the section refresh (~900ms on mobile). */
    if(window.__sfOpenDrawer) window.__sfOpenDrawer(true);
    var code=CODES[state.n];
    /* Il popup puo' aver regalato un codice jackpot (80%, vive 2 ore): Shopify ne tiene
       UNO solo, quindi sparare il nostro /discount/ qui lo cancellerebbe in silenzio
       proprio mentre la cliente compra. Finche' quel codice e' vivo, il tier tace. */
    if(sfJackpotLive()) code='';
    /* Il codice e' indipendente dall'add: vive nella sessione e si attiva appena il
       carrello qualifica (verificato: 3 bra a codice applicato = prezzo pieno, il 4o lo
       riaccende). Aspettarlo prima dell'add costava un round-trip intero in cima al tap.
       redirect:'manual' evita di scaricare i ~300KB di homepage a cui punta il 302: il
       cookie viene scritto lo stesso (misurato: 0 byte, 350ms invece di 589). */
    var pre=code?fetch('/discount/'+code,{redirect:'manual'}).catch(function(){}):Promise.resolve();
    var fail=function(msg){ if(window.__sfCloseDrawer) window.__sfCloseDrawer(); alert(msg); btn.innerHTML=prev; busy=false; };
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
    .then(function(r){
      /* l'add e' finito: il codice, partito insieme, di norma e' gia' atterrato */
      return pre.then(function(){ return r; });
    }).then(function(r){
      if(r&&r.ok){
        /* refresh + open via the drawer's shared refresher (runs tier sync too,
           so the discount always matches the RESULTING bra count, not just the
           pack size — e.g. adding a 2-pack on top of 1 in cart => FITSET). */
        var done=function(){ btn.innerHTML=prev; busy=false; };
        if(window.__sfRefreshDrawer){
          window.__sfRefreshDrawer(true).then(done).catch(function(){ done(); location.href='/cart'; });
        } else { location.href='/cart'; }
      }
      else{ fail(T.cartErr+' [HTTP '+r.status+']'); }
    }).catch(function(){ fail(T.cartErr+' [network]'); });
  }
  atc.addEventListener('click',function(){ addToCart(atc); });
  /* rimosso: #barbtn — la sticky bar ha solo .jump-buy, nessun add-to-cart proprio */

  /* mid-page CTAs scroll back to the buy box (size must be chosen there) */
  document.querySelectorAll('.jump-buy').forEach(function(b){
    b.addEventListener('click',function(){ document.getElementById('buybox').scrollIntoView({behavior:'smooth'}); });
  });
})();

/* rimosso: IIFE countdown consegna — #delCountdown/#delDates non esistono piu' nel markup */

/* Scroll reveal for content sections — gated so no-JS shows everything; reduced-motion safe */
(function(){
  if(matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els=[].slice.call(document.querySelectorAll('.wyl,.sx'));
  if(!els.length || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('reveal-on');
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  },{threshold:.1,rootMargin:'0px 0px -6% 0px'});
  els.forEach(function(el){ io.observe(el); });
  /* failsafe: garantisce che niente resti nascosto SOPRA la piega. Sotto la piega decide
     l'observer, altrimenti l'animazione di reveal finisce fuori schermo e non la vede nessuno. */
  setTimeout(function(){ els.forEach(function(el){ if(!el.classList.contains('in') && el.getBoundingClientRect().top < innerHeight) el.classList.add('in'); }); }, 3000);
})();

/* bna story-scroll: each hour-stop activates as it enters the viewport */
(function(){
  var stops=[].slice.call(document.querySelectorAll('.bna-stop'));
  if(!stops.length) return;
  if(!('IntersectionObserver' in window)){ stops.forEach(function(st){st.classList.add('go');}); return; }
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('go'); io.unobserve(e.target); } });
  },{threshold:.5,rootMargin:'0px 0px -8% 0px'});
  stops.forEach(function(st){ io.observe(st); });
  /* stesso failsafe del reveal: solo quello gia' in viewport, il resto lo attiva l'observer */
  setTimeout(function(){ stops.forEach(function(st){ if(!st.classList.contains('go') && st.getBoundingClientRect().top < innerHeight) st.classList.add('go'); }); },6000);
})();

/* lazy media: posters and video/image sources arrive only when the element is near.
   Two observers on purpose:
   - posters and gallery images get horizontal slack and pop in before you swipe to them
   - video sources have NO horizontal slack: any side margin would pull the 1.8MB montage
     back into the initial load. */
(function(){
  var posters=[].slice.call(document.querySelectorAll('[data-poster]'));
  var srcs=[].slice.call(document.querySelectorAll('[data-lazysrc]'));
  if(!posters.length && !srcs.length) return;
  function setPoster(el){ var p=el.getAttribute('data-poster'); if(p){ el.setAttribute('poster',p); el.removeAttribute('data-poster'); } }
  /* upgrade, not first-write: the markup ships a ~1KB blurred placeholder in `src`/`poster` so a slow
     connection never shows an empty box. So this MUST overwrite an existing src, or the placeholder
     would be the final image. `data-lazysrc` is dropped after the swap: that also drops the CSS blur. */
  function setSrc(el){
    var s=el.getAttribute('data-lazysrc');
    if(s){ el.setAttribute('src',s); el.removeAttribute('data-lazysrc'); }
    if(el.tagName==='VIDEO'){ var p=el.play(); if(p&&p.catch){p.catch(function(){});} }
  }
  if(!('IntersectionObserver' in window)){ posters.forEach(setPoster); srcs.forEach(setSrc); return; }
  var pio=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ setPoster(e.target); pio.unobserve(e.target); } });
  },{rootMargin:'200px 600px',threshold:.01});
  posters.forEach(function(el){ pio.observe(el); });
  /* videos keep the tight box (no side slack = the 1.8MB montage stays out of the initial load) */
  var sio=new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(e.isIntersecting){ setSrc(e.target); }
      else if(e.target.tagName==='VIDEO' && e.target.getAttribute('src')){ e.target.pause(); }
    });
  },{rootMargin:'150px 0px',threshold:.01});
  srcs.forEach(function(el){ if(el.tagName==='VIDEO') sio.observe(el); });
  /* ponytail: gallery images get ~3 slides of look-ahead so a fast swipe lands on a loaded image,
     not a grey box. Root MUST be the track: rootMargin only grows the root's own box, it can't
     see past an ancestor scroller's clip, so a viewport-rooted margin buys nothing here.
     Images only — the video above is the heavy one. */
  function warm(el){
    if(el.hasAttribute('data-poster')) setPoster(el);       // video: poster only, the mp4 stays lazy
    else if(el.hasAttribute('data-lazysrc')) setSrc(el);
    else el.loading='eager';
  }
  var scrollers=[].slice.call(document.querySelectorAll('#galtrack,.sfreel-track'));
  var armers=[];
  scrollers.forEach(function(sc){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ warm(e.target); io.unobserve(e.target); } });
    },{root:sc,rootMargin:'0px 1200px',threshold:.01});
    armers.push(function(){ [].forEach.call(sc.querySelectorAll('img[data-lazysrc],img[loading="lazy"],[data-poster]'),function(el){ io.observe(el); }); });
  });
  /* after load: the look-ahead is what makes a fast swipe land on a loaded image, so it stays.
     Misurato 2026-07-29 contro il baseline del 25/07: costa 669KB, non i ~330KB che diceva prima
     questo commento (mechanism 248 + antiroll 197 + back 182 + poster montage 42). Resta legato
     all'evento load apposta: quei byte non devono mai competere con l'LCP. */
  var arm=function(){ armers.forEach(function(f){ f(); }); };
  if(document.readyState==='complete') arm(); else addEventListener('load',arm,{once:true});
  function inScroller(el){ for(var i=0;i<scrollers.length;i++){ if(scrollers[i].contains(el)) return true; } return false; }
  var iio=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ warm(e.target); iio.unobserve(e.target); } });
  },{rootMargin:'150px 600px',threshold:.01});
  srcs.forEach(function(el){ if(el.tagName!=='VIDEO' && !inScroller(el)) iio.observe(el); });
})();
